import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import { OFFERING_LINKS, LEGAL_LINKS, RISK_DISCLAIMER, SITE } from "../config/site";

export default function Footer() {
  const year = new Date().getFullYear();

  const cols = [
    {
      title: "Offerings",
      links: OFFERING_LINKS,
    },
    {
      title: "Fund",
      links: [
        { label: "Home", to: "/" },
        { label: "About Us", to: "/about" },
        { label: "Contact Us", to: "/contact" },
        { label: "Risk Disclosure", to: "/risk-disclosure" },
      ],
    },
    {
      title: "Legal & Transparency",
      links: LEGAL_LINKS,
    },
  ];

  return (
    <footer className="relative border-t border-gold-400/12 bg-ink-800">
      <div className="absolute inset-0 bg-grid-fade opacity-40 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 pt-16 pb-10">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div className="flex flex-col gap-5">
            <Link to="/" data-testid="footer-logo" aria-label="Kalki AI Fund — Home" className="w-fit group">
              <img
                src="/kalki-wordmark.png"
                alt="Kalki AI Fund full logo — gold shield emblem with KALKI AI wordmark"
                className="h-12 w-auto mix-blend-screen transition-transform duration-500 group-hover:scale-[1.03]"
              />
            </Link>
            <p className="text-sm text-zinc-500 leading-relaxed max-w-xs">
              A structured approach to algorithmic trading and digital asset opportunities — with
              custody arrangements and risks explained plainly.
            </p>
            <a
              href={`mailto:${SITE.contactEmail}`}
              data-testid="footer-contact-email"
              className="inline-flex items-center gap-2 text-sm text-gold-300 hover:text-gold-200 transition-colors w-fit"
            >
              <Mail size={14} />
              {SITE.contactEmail}
            </a>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold-400/70 mb-5">
                {col.title}
              </p>
              <ul className="flex flex-col gap-3">
                {col.links.map((l) => (
                  <li key={l.to + l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.to.replace("/", "") || "home"}`}
                      className="text-sm text-zinc-400 hover:text-gold-200 transition-colors duration-300 inline-flex items-center gap-1.5 group"
                    >
                      {l.label}
                      <ArrowUpRight
                        size={11}
                        className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 text-gold-400"
                      />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 rounded-2xl border border-gold-400/12 bg-gold-400/[0.03] p-5">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold-400/80 mb-3">
            Risk disclaimer
          </p>
          <p className="text-xs leading-relaxed text-zinc-500">{RISK_DISCLAIMER}</p>
        </div>

        <div className="mt-8 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-zinc-600" data-testid="footer-copyright">
            © {year} Kalki AI Fund. All rights reserved. · {SITE.domain.replace("https://", "")}
          </p>
          <p className="text-xs text-zinc-600 font-mono">
            Content reviewed for legal & regulatory requirements prior to publication
          </p>
        </div>
      </div>
    </footer>
  );
}